import PropTypes from 'prop-types'

import Styled from './berthing-activity.styled'
import useHooks from './berthing-activity.hooks'

const BerthingActivity = ({ layout, activity, handleToggleExpand }) => {
  const { methods } = useHooks()

  return (
    <Styled.Container>
        <Styled.Table size={layout}>
          <colgroup>
            <col style={{ width: layout === 3 ? 'auto' : '25%' }} />
            <col style={{ width: '10%' }} />
            <col style={{ width: layout === 3 ? '2%' : '5%' }} />
            <col style={{ width: '25%' }} />
            <col style={{ width: '10%' }} />
            <col style={{ width: '20%' }} />
            <col style={{ width: '5%' }} />
          </colgroup>
          <thead>
            <Styled.HeaderRow>
              <Styled.Th size={layout} colSpan={2}>
                <span style={{ gap: 8, display: 'flex', alignItems: 'center' }}>
                <Styled.VesselIcon alt={activity.activity_name || 'activity-icon'} src={activity.vessel_icon} />
                <p>{activity.activity_name}</p>
              </span>
              </Styled.Th>
              <Styled.Th size={layout}>
                <Styled.ColorDot backgroundColor={methods.mapActivityColorStatus(activity.progress_task_header_list)} />
              </Styled.Th>
              <Styled.Th size={layout}>
                <span>Time <b> {methods.formatDate(activity.start_date, 'DD MMM YY')} </b> | <b>{methods.formatDate(activity.start_date, 'HH:mm')}</b></span>
              </Styled.Th>
              <Styled.Th size={layout}>
                <b>{methods.formatDuration(methods.formatDate(activity.start_date), methods.formatDate(activity.finish_date))}</b>
              </Styled.Th>
              <Styled.Th size={layout}>
                <span>Progress <b>{activity.progress}%</b></span>
              </Styled.Th>
              <Styled.Th size={layout}>
                <Styled.ExpandIcon expanded={activity.is_expanded} onClick={() => handleToggleExpand(activity.id)}>
                  <svg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M6 9.61651e-07L11.5 8L0.499999 8L6 9.61651e-07Z' fill='#0A81AD'/></svg>
                </Styled.ExpandIcon>
              </Styled.Th>
            </Styled.HeaderRow>
          </thead>
          <tbody>
            {activity.is_expanded && activity.progress_task_header_list.map((task, taskIndex) => (
              <Styled.HeaderRow key={taskIndex}>
                <Styled.Td size={layout} layout={layout}>{task.task}</Styled.Td>
                <Styled.Td size={layout} layout={layout}>{task.pic}</Styled.Td>
                <Styled.Td size={layout} layout={layout}>
                  <Styled.ColorDot backgroundColor={methods.mapTaskColorStatus(task)} />
                </Styled.Td>
                <Styled.Td size={layout} layout={layout}>{task.level_value}</Styled.Td>
                <Styled.Td size={layout} layout={layout} colSpan={3}>{task.remarks}</Styled.Td>
              </Styled.HeaderRow>
            ))}
          </tbody>
        </Styled.Table>
    </Styled.Container>
  )
}

BerthingActivity.propTypes = {
  layout: PropTypes.number.isRequired,
  activity: PropTypes.shape({
    progress: PropTypes.number.isRequired,
    start_date: PropTypes.string.isRequired,
    vessel_icon: PropTypes.string.isRequired,
    finish_date: PropTypes.string.isRequired,
    activity_name: PropTypes.string.isRequired,
    progress_task_header_list: PropTypes.arrayOf(
      PropTypes.shape({
        pic: PropTypes.string.isRequired,
        task: PropTypes.string.isRequired,
        remarks: PropTypes.string.isRequired,
        level_value: PropTypes.string.isRequired,
      })
    ).isRequired,
  }).isRequired,
  handleToggleExpand: PropTypes.func.isRequired,
}

export default BerthingActivity